// extracted by mini-css-extract-plugin
export default {"antLayout":"PageWithHeaderLayout_antLayout__+1LZ-","mainContent":"PageWithHeaderLayout_mainContent__6vUWY"};